export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[580px] md:min-h-[680px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20luxurious%20fashion%20discovery%20scene%20with%20curated%20clothing%20pieces%20sneakers%20and%20accessories%20artistically%20arranged%20on%20a%20light%20marble%20surface%2C%20soft%20golden%20hour%20sunlight%20casting%20gentle%20shadows%20through%20sheer%20linen%20curtains%2C%20elegant%20lifestyle%20composition%20with%20warm%20terracotta%20sage%20and%20cream%20tones%2C%20high%20end%20editorial%20product%20photography%2C%20sophisticated%20airy%20atmosphere%20with%20abundant%20negative%20space%20for%20text%20overlay%2C%20modern%20aspirational%20aesthetic&width=1600&height=900&seq=sugargoo-hero-v2&orientation=landscape"
          alt="Sugargoo Spreadsheet - Product discovery and fashion shopping resource hub featuring curated items"
          title="Sugargoo Spreadsheet Product Discovery Platform"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/45"></div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 md:px-8 py-20 md:py-28">
        <div className="max-w-2xl">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-accent-100/90 text-accent-700 text-xs font-medium mb-6">
            <i className="ri-sparkling-line"></i>
            <span>Updated Weekly &mdash; 10,000+ Product Finds</span>
          </div>

          <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight">
            Sugargoo Spreadsheet:<br />
            <span className="text-primary-300">Find The Best Products Faster</span>
          </h1>

          <p className="mt-5 text-white/80 text-base md:text-lg leading-relaxed max-w-xl">
            Explore thousands of carefully organized product finds, updated spreadsheets, QC references, shopping guides, and expert reviews to make your Sugargoo shopping experience easier and more enjoyable.
          </p>

          <div className="flex flex-col sm:flex-row gap-3.5 mt-8">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center gap-2 px-7 py-3.5 bg-primary-500 hover:bg-primary-600 text-white text-sm md:text-base font-semibold rounded-full transition-all duration-200 whitespace-nowrap"
            >
              Sugargoo Spreadsheet
              <i className="ri-arrow-right-up-line"></i>
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center gap-2 px-7 py-3.5 bg-white/15 hover:bg-white/25 text-white border border-white/30 text-sm md:text-base font-semibold rounded-full transition-all duration-200 backdrop-blur-sm whitespace-nowrap"
            >
              Buy It Now
              <i className="ri-shopping-bag-line"></i>
            </a>
          </div>

          <div className="flex flex-wrap items-center gap-6 mt-10">
            <div className="flex items-center gap-2 text-white/70 text-xs">
              <i className="ri-checkbox-circle-line text-accent-400"></i>
              <span>Updated Product Database</span>
            </div>
            <div className="flex items-center gap-2 text-white/70 text-xs">
              <i className="ri-checkbox-circle-line text-accent-400"></i>
              <span>Beginner Friendly Guides</span>
            </div>
            <div className="flex items-center gap-2 text-white/70 text-xs">
              <i className="ri-checkbox-circle-line text-accent-400"></i>
              <span>Shopping Cost Analysis</span>
            </div>
            <div className="flex items-center gap-2 text-white/70 text-xs">
              <i className="ri-checkbox-circle-line text-accent-400"></i>
              <span>Independent Reviews</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}